import React from "react";
import "./MesaCard.css";
import { useMesa } from "../../../contexto/provider/MesaContext.js";

export default function MesaCard({ id, seleccionada, onSelect }) {
  const { mesaTieneOrdenes } = useMesa();
  const ocupada = mesaTieneOrdenes(id);
  const estado = ocupada ? "ocupada" : "libre";

  return (
    <div
      className={`mesa-item -${estado}  ${seleccionada ? "mesa-seleccionada" : ""}`}
      onClick={() => onSelect(id)} // 👈 AVISA AL PADRE
    >
      <div className="mesa-titulo">Mesa</div>
      <div className="mesa-numero">{id}</div>
      <div className="mesa-estado">{estado}</div>
    </div>
  );
}
